import { Box, Typography } from '@mui/material';
import overviewData from '../data/overview.json';
import { WorkInstructions } from '../WorkInstructions';

export const Overview = () => {
    const overview = overviewData.find((section) => section.title === 'Overview');
    const detailSections = overviewData.filter(
        (section, index, sections) =>
            section.title !== 'Overview' &&
            sections.findIndex((candidate) => candidate.title === section.title) === index
    );
    const nav = [
        { name: 'Home', path: '/home/viewQuote' },
        { name: 'Support', path: '/home/support' },
        { name: 'Elvis Connect Overview', path: '/home/support/overview' },
    ];

    return (
        <WorkInstructions title="ELVIS Connect Overview" nav={nav} sections={detailSections}>
            {overview?.items && (
                <Box component="dl" sx={{ m: 0, mb: 4, pb: 3, borderBottom: '1px solid #dce3e8', display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' }, gap: 2.5 }}>
                    {overview.items.map((item) => (
                        <Box key={item.name}>
                            <Typography component="dt" sx={{ color: '#003b7a', fontSize: 14, fontWeight: 700, mb: 0.5 }}>{item.name}</Typography>
                            <Typography component="dd" sx={{ m: 0, color: '#526575', fontSize: 13, lineHeight: 1.7 }}>{item.description}</Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </WorkInstructions>
    );
};
